'use client';
import React from 'react';
import Modal from 'react-modal';
import ReactPlayer from 'react-player';
import { XCircleIcon } from '@heroicons/react/24/outline';

interface ModalVideoPlayerProps {
  isOpen: boolean;
  videoLink?: string;
  onClose: () => void;
  children?: React.ReactNode;
}

export const ModalVideoPlayer = ({ isOpen, videoLink, onClose }: ModalVideoPlayerProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Video Modal"
      className={
        'fixed left-1/2 top-1/2 z-50 h-full w-full -translate-x-1/2 -translate-y-1/2 transform p-0 lg:h-full lg:w-full lg:p-10'
      }
      ariaHideApp={false}
      overlayClassName={'bg-opacity-60 bg-gray-1 fixed top-0 left-0 w-full h-full'}
      bodyOpenClassName="overflow-hidden"
    >
      <ReactPlayer
        url={videoLink}
        config={{
          wistia: {
            options: {
              autoplay: true,
              mute: false,
            },
          },
        }}
        playing={isOpen}
        width={'100%'}
        height={'100%'}
        controls={true}
      />
      <button
        onClick={e => {
          e.stopPropagation();
          onClose();
        }}
        className="absolute left-2 top-2 z-50 flex size-10 cursor-pointer items-center justify-center p-0 md:left-auto md:right-2 md:top-2 lg:right-4 lg:top-4 lg:h-10 lg:w-10"
      >
        <XCircleIcon className="size-10 text-white" />
      </button>
    </Modal>
  );
};
